import api, { API } from "@/lib/api";

export function fileUrl(fileId, download = false) {
  if (!fileId) return null;
  const token = localStorage.getItem("ht_token");
  return `${API}/files/${fileId}/download?auth=${token}${download ? "&dl=1" : ""}`;
}

export async function uploadFile(file) {
  const form = new FormData();
  form.append("file", file);
  const { data } = await api.post("/upload", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data; // { file_id, filename, content_type }
}
